import { createNamedContext } from '@/utils';
import type { BrandThemingContextValue, SurveyThemingContextValue, WhitelabelingPaletteContextValue } from './interfaces';

export const BrandThemingContext = createNamedContext<BrandThemingContextValue>(undefined, 'Branding.Theming.Context');

export const WhitelabelingPaletteContext = createNamedContext<WhitelabelingPaletteContextValue>(undefined, 'Branding.WhitelabelingPalette.Context');

export const SurveyThemingContext = createNamedContext<SurveyThemingContextValue>(undefined, 'Branding.SurveyTheming.Context');